import FeedbackStore from "./FeedbackStore";

const feedbackStore = new FeedbackStore();

export default feedbackStore;
